import styled from 'styled-components/macro';
export const HamburgareWrapper = styled.ul`
  margin: 0;
  display: flex;
  padding: 0;
  flex-direction: column;
`;
